module.exports = __webpack_public_path__ + "img/dailytelegraph.8bb3d8a7.png";